/** Import our SCSS file so Webpack can compile */
import '../scss/main.scss';

/** Components */
import initHeader from '../js/components/Header';

/** Blocks */
import initHero from '../../blocks/hero/hero';
import initTextCarousel from '../../blocks/text-carousel/text-carousel';
import initTextMedia from '../../blocks/text-media/text-media';
import initContactBanner from '../../blocks/contact-banner/contact-banner';

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initHero();
  initTextCarousel();
  initTextMedia();
  initContactBanner();
});
